import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ProjectsPage = () => {
  const [activeFilter, setActiveFilter] = useState('todos');
  const [selectedProject, setSelectedProject] = useState<any>(null);

  const projectFilters = [
    { id: 'todos', name: 'Todos los Proyectos', count: 15 },
    { id: 'industrial', name: 'Industrial', count: 5 },
    { id: 'mineria', name: 'Minería', count: 3 },
    { id: 'construccion', name: 'Construcción', count: 4 },
    { id: 'energia', name: 'Energía', count: 3 }
  ];

  const projects = [
    {
      id: 1,
      title: 'Planta de Tratamiento de Minerales',
      category: 'mineria',
      description: 'Diseño e implementación de planta de procesamiento de minerales en región de Arequipa',
      image: 'próximamente',
      status: 'Completado',
      year: '2025',
      client: 'Compañía Minera Andina',
      location: 'Arequipa, Perú',
      investment: '$45 millones',
      details: [
        'Tratamiento de 2,000 TM/día de mineral',
        'Tecnología de flotación avanzada',
        'Sistema de control automatizado',
        'Cumplimiento de normas ambientales'
      ]
    },
    {
      id: 2,
      title: 'Edificio Industrial Multiuso',
      category: 'construccion',
      description: 'Construcción de centro industrial de 5 niveles para empresa manufacturera',
      image: 'próximamente',
      status: 'Completado',
      year: '2024',
      client: 'Industrias Pacífico S.A.C.',
      location: 'Lima, Perú',
      investment: '$12 millones',
      details: [
        'Área construida: 8,500 m²',
        'Estructura de acero laminado',
        'Sistema HVAC de última generación',
        'Instalaciones eléctricas industriales'
      ]
    },
    {
      id: 3,
      title: 'Central Hidroeléctrica',
      category: 'energia',
      description: 'Diseño y construcción de central hidroeléctrica de 50MW en región de Junín',
      image: 'próximamente',
      status: 'En Progreso',
      year: '2024-2025',
      client: 'Generación Andina S.A.',
      location: 'Junín, Perú',
      investment: '$80 millones',
      details: [
        'Capacidad: 50 MW',
        'Turbina Francis de alta eficiencia',
        'Línea de transmisión 220 kV',
        'Sistema de control SCADA'
      ]
    },
    {
      id: 4,
      title: 'Puente Vehicular',
      category: 'construccion',
      description: 'Diseño y construcción de puente vehicular sobre río Mantaro',
      image: 'próximamente',
      status: 'Planeado',
      year: '2025-2026',
      client: 'Ministerio de Transportes',
      location: 'Huancavelica, Perú',
      investment: '$25 millones',
      details: [
        'Longitud: 280 metros',
        'Ancho: 12 metros',
        'Diseño antisísmico',
        'Durabilidad: 100 años'
      ]
    },
    {
      id: 5,
      title: 'Refinería de Petróleo',
      category: 'industrial',
      description: 'Modernización de refinería con tecnología de punta',
      image: 'próximamente',
      status: 'Completado',
      year: '2023',
      client: 'PetroPerú',
      location: 'Talara, Perú',
      investment: '$120 millones',
      details: [
        'Capacidad: 65,000 barriles/día',
        'Tecnología de hidrotratamiento',
        'Sistema de control de emisiones',
        'Eficiencia energética mejorada'
      ]
    },
    {
      id: 6,
      title: 'Sistema de Transporte de Concentrado',
      category: 'mineria',
      description: 'Implementación de sistema de transporte de minerales para empresa minera',
      image: 'próximamente',
      status: 'Completado',
      year: '2024',
      client: 'Minera San Cristóbal',
      location: 'Puno, Perú',
      investment: '$35 millones',
      details: [
        'Transporte: 3,500 TM/hora',
        'Longitud: 15 km',
        'Sistema de bandas transportadoras',
        'Estaciones de bombeo'
      ]
    },
    {
      id: 7,
      title: 'Planta de Producción de Ácido Sulfúrico',
      category: 'industrial',
      description: 'Diseño e implementación de planta de producción de ácido sulfúrico',
      image: 'próximamente',
      status: 'En Progreso',
      year: '2024-2025',
      client: 'Química Andina S.R.L.',
      location: 'Moquegua, Perú',
      investment: '$55 millones',
      details: [
        'Producción: 200 TPD',
        'Tecnología de doble contacto',
        'Sistema de captación de SO₂',
        'Control de emisiones avanzado'
      ]
    },
    {
      id: 8,
      title: 'Terminal Portuaria',
      category: 'construccion',
      description: 'Construcción de terminal portuaria para exportación de minerales',
      image: 'próximamente',
      status: 'Planeado',
      year: '2025-2026',
      client: 'Puertos del Sur S.A.',
      location: 'Ilo, Perú',
      investment: '$95 millones',
      details: [
        'Muelle de 400 metros',
        'Capacidad: 8 millones TM/año',
        'Sistema de carga/descarga automatizado',
        'Infraestructura de almacenamiento'
      ]
    }
  ];

  const filteredProjects = activeFilter === 'todos' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 page-top-spacing">
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-display font-bold text-primary-dark mb-4">Nuestros Proyectos</h1>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
            Explora algunos de nuestros proyectos más destacados en ingeniería e industrial solutions.
          </p>
        </motion.div>

        {/* Project Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {projectFilters.map((filter) => (
            <motion.button
              key={filter.id}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                activeFilter === filter.id
                  ? 'bg-primary-dark text-white shadow-lg'
                  : 'bg-white text-primary-dark hover:bg-gray-100 border border-gray-200'
              }`}
              onClick={() => setActiveFilter(filter.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {filter.name} 
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
                activeFilter === filter.id
                  ? 'bg-white bg-opacity-20'
                  : 'bg-primary-accent bg-opacity-20'
              }`}>
                {filter.count}
              </span>
            </motion.button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 card-elevated"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
            >
              <div className="h-48 bg-gray-200 overflow-hidden">
                {project.image === 'próximamente' ? (
                  <div className="h-full w-full flex items-center justify-center text-gray-500 bg-gray-100">
                    <div className="text-center p-4">
                      <div className="text-4xl mb-2">🚧</div>
                      <p className="text-sm font-medium">Próximamente</p>
                    </div>
                  </div>
                ) : (
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-subheading font-bold text-primary-dark">{project.title}</h3>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    project.status === 'Completado' ? 'bg-green-100 text-green-800' :
                    project.status === 'En Progreso' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-blue-100 text-blue-800'
                  }`}>
                    {project.status}
                  </span>
                </div>
                
                <p className="text-gray-600 mb-4">{project.description}</p>
                
                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-medium">Cliente:</span>
                    <span>{project.client}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium">Ubicación:</span>
                    <span>{project.location}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium">Año:</span>
                    <span>{project.year}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium">Inversión:</span>
                    <span>{project.investment}</span>
                  </div>
                </div>
                
                <div className="mt-6">
                  <h4 className="font-semibold text-primary-accent mb-2">Detalles del Proyecto:</h4>
                  <ul className="space-y-1">
                    {project.details.slice(0, 3).map((detail, idx) => (
                      <li key={idx} className="flex items-start text-gray-600 text-small">
                        <span className="text-primary-accent mr-2 mt-1">•</span>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <button
                  onClick={() => setSelectedProject(project)}
                  className="mt-6 w-full bg-primary-dark hover:bg-[#0d1c32] text-white font-medium py-3 rounded-lg transition duration-300"
                >
                  Ver Detalles
                </button>
              </div>
              <div className="bg-gradient-to-r from-primary-dark to-primary-accent h-1 w-full"></div>
            </motion.div>
          ))}
        </div>

        {/* Project Statistics */}
        <motion.div 
          className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-8 text-white"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h2 className="text-heading font-bold mb-6 text-center">Estadísticas de Proyectos</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="p-4">
              <div className="text-4xl font-bold text-primary-accent mb-2">200+</div>
              <p>Proyectos Completados</p>
            </div>
            <div className="p-4">
              <div className="text-4xl font-bold text-primary-accent mb-2">15+</div>
              <p>Años de Experiencia</p>
            </div>
            <div className="p-4">
              <div className="text-4xl font-bold text-primary-accent mb-2">50+</div>
              <p>Clientes Satisfechos</p>
            </div>
            <div className="p-4">
              <div className="text-4xl font-bold text-primary-accent mb-2">12</div>
              <p>Departamentos Cubiertos</p>
            </div>
          </div>
        </motion.div>

        {/* Project Details Modal */}
        <AnimatePresence>
          {selectedProject && (
            <motion.div
              className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedProject(null)}
            >
              <motion.div
                className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
                initial={{ scale: 0.9, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.9, y: 20 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                  <h3 className="text-xl font-bold text-primary-dark">{selectedProject.title}</h3>
                  <button
                    onClick={() => setSelectedProject(null)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="p-6">
                  <div className="mb-6">
                    <div className="h-64 bg-gray-100 rounded-xl flex items-center justify-center">
                      {selectedProject.image === 'próximamente' ? (
                        <div className="text-center p-4">
                          <div className="text-4xl mb-2">🚧</div>
                          <p className="text-sm font-medium">Próximamente</p>
                        </div>
                      ) : (
                        <img
                          src={selectedProject.image}
                          alt={selectedProject.title}
                          className="w-full h-full object-cover rounded-xl"
                        />
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <p className="text-sm text-gray-500">Estado</p>
                      <p className="font-medium">{selectedProject.status}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Año</p>
                      <p className="font-medium">{selectedProject.year}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Cliente</p>
                      <p className="font-medium">{selectedProject.client}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Ubicación</p>
                      <p className="font-medium">{selectedProject.location}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Inversión</p>
                      <p className="font-medium">{selectedProject.investment}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Categoría</p>
                      <p className="font-medium capitalize">{selectedProject.category}</p>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h4 className="font-bold text-primary-dark mb-3">Descripción</h4>
                    <p className="text-gray-600">{selectedProject.description}</p>
                  </div>

                  <div>
                    <h4 className="font-bold text-primary-dark mb-3">Detalles del Proyecto</h4>
                    <ul className="space-y-2">
                      {selectedProject.details.map((detail: string, idx: number) => (
                        <li key={idx} className="flex items-start text-gray-700">
                          <span className="text-primary-accent mr-2 mt-1">✓</span>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-8 flex justify-end">
                    <button
                      onClick={() => setSelectedProject(null)}
                      className="bg-primary-dark hover:bg-[#0d1c32] text-white font-medium py-3 px-6 rounded-lg transition duration-300"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ProjectsPage;